import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import { getYear } from "date-fns";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { palette } from "lib/miolo";

interface IFoundedYearCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

export default function FoundedYearCard({ issuer }: IFoundedYearCardProps) {
  if (!issuer.foundedYear) {
    return null;
  }

  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 22 22">
      <g transform="translate(-27 -34)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path
          stroke="currentColor"
          strokeWidth={2}
          d="M28 40.333a2.667 2.667 0 012.667-2.666h14a2.667 2.667 0 012.666 2.666v11.334a2.667 2.667 0 01-2.666 2.666h-14A2.666 2.666 0 0128 51.667V40.333zM32.333 35v4.667M43 35v4.667M32 43h11.333"
        />
      </g>
    </svg>
  );

  const diffInYears = getYear(new Date()) - parseFloat(issuer.foundedYear);

  return (
    <div>
      <IconCard primaryColor={palette.oceanGreen} secondaryColor={palette.grannyApple} icon={icon}>
        {diffInYears >= 1 ? (
          <div className="flex items-baseline">
            <CardValue>{issuer.foundedYear}</CardValue>

            <div className="ml-2">
              <small className="font-aeonik font-medium italic text-gray-500">
                (há {diffInYears} {diffInYears === 1 ? "ano" : "anos"})
              </small>
            </div>
          </div>
        ) : (
          <CardValue>{issuer.foundedYear}</CardValue>
        )}

        <CardDescription>Fundação</CardDescription>
      </IconCard>
    </div>
  );
}
